import {
    subWeeks,
    subMonths,
    subYears,
    differenceInCalendarDays,
    subDays
} from 'date-fns'

export function lastWeek():Date {
    return subWeeks(new Date(), 1)
}

export function lastFifteenDays():Date {
    return subDays(new Date(), 15)
}

export function lastMonth():Date {
    return subMonths(new Date(), 1)
}

export function lastYear():Date {
    return subYears(new Date(), 1)
}

export function differenceInDays(fromDate:Date, toDate:Date):number {
    return differenceInCalendarDays(fromDate, toDate)
}
